import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_NEW_PROGRAM_DETAILS, GET_NEW_PROGRAM_DETAILS_ERROR, GET_NEW_PROGRAM_DETAILS_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getNewProgramDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.params?.id}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_NEW_PROGRAM_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_NEW_PROGRAM_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_NEW_PROGRAM_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetNewProgramDetails() {
  yield takeEvery(GET_NEW_PROGRAM_DETAILS, getNewProgramDetails);
}

function* getNewProgramDetailsSaga() {
  yield all([fork(watchGetNewProgramDetails)]);
}

export default getNewProgramDetailsSaga;
